import React from 'react';
import randomstring from 'uuid/v4';
import Grid from '@material-ui/core/Grid';
import Item from './Item';
import Instance from './Instance';

class Activity extends React.Component {
    render() {
        const { active, data, info, params, editable } = this.props;
        return (
            <div className={'flex_full_column padding_bottom_9'}>
                {info && <Instance key={randomstring()} info={info} />}
                <div className="flex_full overflow_y_scroll padding_top_12 showbarHeight ">
                    <Grid container>
                        {data &&
                            data.map((item, i) => {
                                return (
                                    <Item
                                        key={randomstring()}
                                        data={item}
                                        last={data.length === i + 1}
                                        active={active === item.codigo}
                                        params={params}
                                        editable={editable}
                                    />
                                );
                            })}
                    </Grid>
                </div>
            </div>
        );
    }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/components/complex/forms/Activity.js